/*
    sidebar component should be a component usable for all main views
*/
import React, { useState } from "react";
import { rbac } from "../index";
import t from "../../../helpers/t";
import PushChangesButton from "./PushChangesButton";
import { ListItem } from "../styled_components/exporter";
import { $, Foundation, moment } from "../../../../../vendor";
import { Biscuit, Uri } from "../../../../utils";

const JobsSidebar = (props) => {
  const [globalFilter, setGlobalFilter] = useState({}); // set empty object, there are no filters set by default

  const [statusFilter, setStatusFilter] = useState({ value: "all" }); // 'all', 'active', 'inactive'
  const [roleFilter, setRoleFilter] = useState({ value: "all" }); // 'all', 'admin', 'manager', 'booking-manager', 'mediator', optional: 'manager-location', 'garage-staff', 'guide'

  const onToggleLeftBar = (ev) => {
    $("#inb-c-sidebar").toggleClass("open");
    $("html,body").scrollTop(0);
  };

  let first_url_part = "https://general-frontend.inbooma.net/";
  let api_url = "https://api.inbooma.net/api/";
  if (document.location.host.toLowerCase().indexOf("test-web.inbooma.net") >= 0) {
    first_url_part = "https://test-general-frontend.inbooma.net/";
    api_url = "https://test-api.inbooma.net/api/";
  } else if (document.location.host.toLowerCase().indexOf("staging-web.inbooma.net") >= 0) {
    first_url_part = "https://staging-general-frontend.inbooma.net/";
    api_url = "https://staging-api.inbooma.net/api/";
  }
  let surl = "&startPage=register";
  let url = "&i18n.lng=" + Biscuit.get("user.lang").replace("-", "_") + "#/";
  surl += url;
  let frontend_url = Biscuit.get("client.frontend_url");
  if (frontend_url != null && frontend_url != "" && frontend_url != "null") {
    url = frontend_url;
  }
  let client_hash = Uri.generateClientHash(Biscuit.get("user.client_id"));
  let bookingUrl = first_url_part + "?hash=" + client_hash + url;
  return (
    <aside id="inb-c-sidebar" className="frontend_locations-sidebar" style={{ float: "left" }}>
      <header className="inb-c-left-bar__title">
        <h1 className="inb-page-title">{t("jobsExtended", null, "capital")}</h1>
      </header>

      <footer
        className="inb-c-left-bar__footer small-only-float-container"
        data-inb-action-link="write"
      >
        <a
          id="link_booking_frontend"
          className={"button beautify beautify-" + Biscuit.get("user.client_id")}
          href={bookingUrl}
          rel="noopener noreferrer"
          target="_blank"
        >
          <i className="fi fi-info"></i>
          <span>{t("booking_frontend", null, "capital")}</span>
        </a>

        {rbac.hasPermission("write") && (
          <PushChangesButton
            dispatch={props.dispatch}
            showNotification={props.showNotification}
            forceReInit={props.forceReInit}
            setJobs={props.setJobs}
          />
        )}
      </footer>
    </aside>
  );
};

export default JobsSidebar;
